export default "__VITE_ASSET__f7_qIdVD__"